import DownloadButton from "./DownloadButton";

const DocumentationDownloadButton = ({ name, url }) => {
  const handleDownloadFile = async () => {
    window.open(url, "_blank");
    return null;
  };

  return (
    <DownloadButton
      tooltip="Download File"
      buildFile={handleDownloadFile}
      fileName={name}
    />
  );
};
export default DocumentationDownloadButton;
